<template>
  <div>
    <ol class="breadcrumb" style="border-radius:0" >
      <li class="breadcrumb-item">
        <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('reports.url')">
          {{ $t('reports.name') }}
        </router-link>
      </li>
      <li class="breadcrumb-item" aria-current="page">{{ $t('touristTax') }}</li>
    </ol>
    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('touristTax') }}
            -
            {{monthName}}
            {{year}}
          </h1>
          <p class="lead text-muted">
            {{ $t('touristTax') }}
            {{ $t('forProperty') }}
            {{property.name}}
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <table class="table table-clean table-vcenter" style="width:100%;">
              <thead>
                <tr>
                  <th>{{ $t('title') }}</th>
                  <th>{{ $t('tax') }}</th>
                  <th>{{ $t('amount') }}</th>
                  <th>{{ $t('quantity') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="report in reports">
                  <td>{{report.title}}</td>
                  <td>{{report.price | price }}€</td>
                  <td>{{report.amount | price }}€</td>
                  <td>{{report.quantity}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';


export default {
  name: 'TouristTax',
  data: () => ({
    title: '',
    property: '',
    reports: []
  }),
  filters: {
    price: function(value){
      return value.toFixed(2)
    },
  },
  computed: {
    monthName: function(){
      if(!this.month) return '';
      return moment(this.month, 'MM').locale(this.$i18n.locale).format('MMMM');
    }
  },
  created(){
    const propSlug = this.$route.params.property;

    this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
    this.year = this.$route.params.year;
    this.month = this.$route.params.month;

    fetch(process.env.VUE_APP_API + '/properties/' + this.property._id + '/tourist-tax/' + this.year + '/' + this.month, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      this.reports = response;
    })
  }
};
</script>

<i18n>
{
  "en": {
    "reports": {
      "name": "Reports",
      "url": "reports"
    },
    "touristTax": "Tourist Tax",
    "forProperty": "for property",
    "title": "Title",
    "tax": "Tax",
    "amount": "Amount",
    "quantity": "Quantity"
  },
  "sl": {
    "reports": {
      "name": "Poročila",
      "url": "porocila"
    },
    "touristTax": "Turistična taksa",
    "forProperty": "nastanitve",
    "title": "Naziv",
    "tax": "Taksa",
    "amount": "Znesek",
    "quantity": "Količina"
  }
}
</i18n>
